import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

// Public
export const getSermons = () => api.get("/sermons").then((r) => r.data);
export const getEvents = () => api.get("/events").then((r) => r.data);
export const getMinistries = () => api.get("/ministries").then((r) => r.data);
export const getBlog = () => api.get("/blog").then((r) => r.data);
export const getBlogPost = (slug) => api.get(`/blog/${slug}`).then((r) => r.data);
export const getConfig = () => api.get("/config").then((r) => r.data);
export const getGallery = () => api.get("/gallery").then((r) => r.data);
export const getTestimonials = () => api.get("/testimonials").then((r) => r.data);

// Archives (public, gated)
export const requestArchiveAccess = (data) => api.post("/archives/access", data).then((r) => r.data);
export const archiveCheckout = (data) => api.post("/archives/checkout", data).then((r) => r.data);
export const archiveVerify = (session_id) => api.get(`/archives/verify/${session_id}`).then((r) => r.data);
export const archiveMarkWatched = (id, token) => api.post(`/archives/${id}/watched`, null, { params: { token } }).then((r) => r.data);
export const getArchives = (token) => api.get("/archives", { params: { token } }).then((r) => r.data);
export const archiveStreamUrl = (id, token) => `${API}/archives/stream/${id}?token=${encodeURIComponent(token)}`;

export const postContact = (data) => api.post("/contact", data).then((r) => r.data);
export const postPrayer = (data) => api.post("/prayer", data).then((r) => r.data);
export const postNewsletter = (data) => api.post("/newsletter", data).then((r) => r.data);
export const postBooking = (data) => api.post("/booking", data).then((r) => r.data);

// Auth
export const authExchange = (session_id) => api.post("/auth/session", { session_id }).then((r) => r.data);
export const authMe = () => api.get("/auth/me").then((r) => r.data);
export const authLogout = () => api.post("/auth/logout").then((r) => r.data);

// Admin
export const adminCreateEvent = (data) => api.post("/admin/events", data).then((r) => r.data);
export const adminUpdateEvent = (id, data) => api.put(`/admin/events/${id}`, data).then((r) => r.data);
export const adminDeleteEvent = (id) => api.delete(`/admin/events/${id}`).then((r) => r.data);

export const adminCreateSermon = (data) => api.post("/admin/sermons", data).then((r) => r.data);
export const adminUpdateSermon = (id, data) => api.put(`/admin/sermons/${id}`, data).then((r) => r.data);
export const adminDeleteSermon = (id) => api.delete(`/admin/sermons/${id}`).then((r) => r.data);

export const adminCreateBlog = (data) => api.post("/admin/blog", data).then((r) => r.data);
export const adminUpdateBlog = (id, data) => api.put(`/admin/blog/${id}`, data).then((r) => r.data);
export const adminDeleteBlog = (id) => api.delete(`/admin/blog/${id}`).then((r) => r.data);

export const adminUploadGallery = (file, caption = "") => {
  const fd = new FormData();
  fd.append("file", file);
  fd.append("caption", caption);
  return api.post("/admin/gallery", fd, { headers: { "Content-Type": "multipart/form-data" } }).then((r) => r.data);
};
export const adminDeleteGallery = (id) => api.delete(`/admin/gallery/${id}`).then((r) => r.data);
export const adminUpdateGalleryCaption = (id, caption) => api.put(`/admin/gallery/${id}`, { caption }).then((r) => r.data);

export const adminCreateTestimonial = (data) => api.post("/admin/testimonials", data).then((r) => r.data);
export const adminUpdateTestimonial = (id, data) => api.put(`/admin/testimonials/${id}`, data).then((r) => r.data);
export const adminDeleteTestimonial = (id) => api.delete(`/admin/testimonials/${id}`).then((r) => r.data);

export const adminSubmissions = () => api.get("/admin/submissions").then((r) => r.data);

// Admin archives
export const adminGetArchives = () => api.get("/admin/archives").then((r) => r.data);
export const adminUploadArchive = (file, meta, onUploadProgress, thumbBlob) => {
  const fd = new FormData();
  fd.append("file", file);
  if (thumbBlob) fd.append("thumbnail", thumbBlob, "thumb.jpg");
  fd.append("title", meta.title || "");
  fd.append("description", meta.description || "");
  fd.append("thumbnail_url", meta.thumbnail_url || "");
  return api.post("/admin/archives", fd, {
    headers: { "Content-Type": "multipart/form-data" },
    onUploadProgress,
  }).then((r) => r.data);
};
export const adminAddArchiveUrl = (data) => api.post("/admin/archives/url", data).then((r) => r.data);
export const adminUpdateArchive = (id, data) => api.put(`/admin/archives/${id}`, data).then((r) => r.data);
export const adminDeleteArchive = (id) => api.delete(`/admin/archives/${id}`).then((r) => r.data);
export const adminArchiveAccessList = () => api.get("/admin/archives/access-list").then((r) => r.data);
export const adminUploadEventPhoto = (id, file) => {
  const fd = new FormData();
  fd.append("file", file);
  return api.post(`/admin/events/${id}/photo`, fd, { headers: { "Content-Type": "multipart/form-data" } }).then((r) => r.data);
};
export const adminGetSubscribers = () => api.get("/admin/subscribers").then((r) => r.data);
export const adminAddSubscriber = (data) => api.post("/admin/subscribers", data).then((r) => r.data);
export const adminBulkAddSubscribers = (entries) => api.post("/admin/subscribers/bulk", { entries }).then((r) => r.data);
export const adminDeleteSubscriber = (id) => api.delete(`/admin/subscribers/${id}`).then((r) => r.data);
export const adminSendNewsletter = (data) => api.post("/admin/subscribers/send", data).then((r) => r.data);

// Resolve a gallery item URL (served through our backend)
export const fileUrl = (storage_path) => `${API}/files/${storage_path}`;
